import axios from '../axios'
import { ApiController } from './types'

const base = '/ocr-inspections'

const apiController: ApiController = {
    getAllInspectionRequests: async (request) => {
        return await axios
            .get(base, { params: request })
            .then(response => response.data)
    },
    getInspectionRequestById: async (request) => {
        return await axios
            .get(`${base}/${request.id}`)
            .then(response => response.data)
    },
    createInspectionRequest: async (request) => {
        return await axios
            .post(base, request)
            .then(response => response.data)
    },
}

export default apiController



